import { getApiInstance } from './Api';

let currentAbortController: AbortController | null = null;

export const fetchWordDefinition = async (
  word: string,
  paragraph: string,
  articleLexileLevel?: string,
) => {
  currentAbortController?.abort();
  currentAbortController = new AbortController();
  try {
    const response = await getApiInstance().post(
      '/dictionary/generate-definition',
      {
        params: { word, paragraph, articleLexileLevel },
      },
      { signal: currentAbortController.signal },
    );
    return response.data;
  } catch (error) {
    if (error.name === 'CanceledError') {
      throw error;
    }
    // Only log non-cancellation errors
    console.error(
      error.response?.data?.error ?? `Unknown error defining word: "${word}".`,
    );
    throw error;
  }
};
